"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.brFormattedIdNumberToIdNumber = exports.brIdNumberToFormattedIdNumber = exports.peFormattedIdNumberToIdNumber = exports.peIdNumberToFormattedIdNumber = exports.clFormattedIdNumberToIdNumber = exports.clIdNumberToFormattedIdNumber = void 0;
var helpers_1 = require("./helpers");
var clIdNumberToFormattedIdNumber = function (str) {
    if (str.length < 4) {
        return str;
    }
    var onlyDigits = str.replace(/\./g, '').replace(/-/g, '').toUpperCase();
    var verifier;
    if (onlyDigits.length >= 8) {
        verifier = onlyDigits.substring(onlyDigits.length - 1);
        onlyDigits = onlyDigits.substring(0, onlyDigits.length - 1);
    }
    return (0, helpers_1.addCharToStr)(onlyDigits, '.', 3, '-', verifier);
};
exports.clIdNumberToFormattedIdNumber = clIdNumberToFormattedIdNumber;
var clFormattedIdNumberToIdNumber = function (formattedIdNumber) { return formattedIdNumber.replace(/\./g, ''); };
exports.clFormattedIdNumberToIdNumber = clFormattedIdNumberToIdNumber;
var peIdNumberToFormattedIdNumber = function (str) { return str.replace(/\D/g, ''); };
exports.peIdNumberToFormattedIdNumber = peIdNumberToFormattedIdNumber;
var peFormattedIdNumberToIdNumber = function (formattedIdNumber) { return formattedIdNumber; };
exports.peFormattedIdNumberToIdNumber = peFormattedIdNumberToIdNumber;
var brIdNumberToFormattedIdNumber = function (str) {
    if (str.length < 4) {
        return str;
    }
    var onlyDigits = str.replace(/\./g, '').replace(/-/g, '');
    var verifier;
    if (onlyDigits.length > 9) {
        verifier = onlyDigits.substring(9);
        onlyDigits = onlyDigits.substring(0, 9);
    }
    return (0, helpers_1.addCharToStr)(onlyDigits, '.', 3, '-', verifier);
};
exports.brIdNumberToFormattedIdNumber = brIdNumberToFormattedIdNumber;
exports.brFormattedIdNumberToIdNumber = exports.clFormattedIdNumberToIdNumber;
